import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import * as workerApi from '@company/services/worker/api';
import { IWorkerJobData } from '@th-types/workerProfile.type';
import QueryKeys from '@constants/queryKeys';
import { MINUTE } from '@constants/various';

interface UseUniversalWorkerDataProps {
  jobAssignmentId?: number;
  workerId?: number; // Fallback for cases without job context
  jobId?: number; // Fallback for cases without job context
  enabled?: boolean;
}

export const useUniversalWorkerData = ({
  jobAssignmentId,
  workerId,
  jobId,
  enabled = true,
}: UseUniversalWorkerDataProps) => {
  const queryKey = jobAssignmentId
    ? `${QueryKeys.WORKER_PROFILE}_jobAssignment_${jobAssignmentId}`
    : `${QueryKeys.WORKER_PROFILE}_${workerId}_${jobId || 'no-job'}_triggerProfileView`;

  return useQuery<IWorkerJobData, AxiosError, IWorkerJobData>({
    queryKey: [queryKey],
    queryFn: () => {
      /**
       * TODO: Create API endpoint that takes jobAssignmentId
       * For now, we need workerId and jobId to call the existing API
       */
      return workerApi.fetchWorkerJobInfo(workerId!, jobId, true);
    },
    enabled: enabled && (jobAssignmentId ? jobAssignmentId > 0 : workerId! > 0),
    staleTime: 5 * MINUTE,
    gcTime: 10 * MINUTE,
  });
};

export default useUniversalWorkerData;
